import * as actions from '../actions/typeOfSubjectActionTypes';


const initialState = {
  typeOfSubjectList: {
    success: false,
    errors: null,
    warnings: null,
    typeOfSubjects: [   
      {
        typeOfSubjectKey: 0,
        languageData: [
          {
            language: "deu",
            name: "..."
          },
          {
            language: "ita",
            name: "..."
          },
          {
            language: "eng",
            name: "..."
          }
        ] 
      }
    ]  
  }
}


function typeOfSubject(state = initialState, action) {  
  switch (action.type) {
    case actions.TYPE_OF_SUBJECT_LIST_LOAD:
      return {
        ...state, 
        typeOfSubjectList: action.typeOfSubjectList
      }    
    default:        
      return state
  } 
}


export default typeOfSubject
